// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1_JJC","cls2":"Unibrow-cls2_Y_b Unibrow-cls1_JJC"};